import { useState, useMemo } from "react";
import fuzzysort from "fuzzysort";

const useSearch = (options, optionProperty, allowCustom) => {
    const [search, setSearch] = useState("");

    const filteredOptions = useMemo(() => {
        // const items = options?.filter((option) => option[optionProperty]?.toString().toLowerCase()?.includes(search?.toLowerCase()));
        let items = search.trim() ? fuzzysort.go(search, options, {key: optionProperty, threshold: 0.1}) : options;

        items = items.map((item) => item.obj || item);


        if (allowCustom && search && !items.some((option) => option[optionProperty]?.toString().toLowerCase() === search.toLowerCase())) {
            return [...items, {[optionProperty]: `Create \`${search}\``}];
        }

        return items;
    }, [search, options, optionProperty, allowCustom]);

    const handleSearchChange = (value) => setSearch(value);

    const resetSearch = () => setSearch("");

    return {
        search, resetSearch, filteredOptions, handleSearchChange, 
    };
};

export default useSearch;
